/* Retro FX layer for V1 Retro funnels: grain, three.js shader gradients, GSAP scroll motion, Locomotive smooth scroll.
   Markup hooks:
     data-fx-gradient="#base,#c1,#c2,#c3"  data-fx-mix="0.6"  -> animated mesh-gradient canvas behind the element's content
     data-fx-parallax="0.15"                                    -> scroll parallax (fraction of travel)
     data-fx-zoom                                               -> image eases from 1.12 to 1 while scrolling through
     data-fx-tilt                                               -> pointer tilt (desktop)
     data-fx-velocity                                           -> marquee rows skew with scroll velocity
   Respects prefers-reduced-motion (static single frame, no smooth scroll). */
(function () {
  if (window.__retroFx) return; window.__retroFx = true;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  function load(src, test) { var M = window.__lxLoad = window.__lxLoad || {}; if (test()) return Promise.resolve(); if (M[src]) return M[src]; var ex = document.querySelector('script[src="' + src + '"]'); M[src] = new Promise(function (res) { if (ex) { ex.addEventListener('load', function () { res(); }); ex.addEventListener('error', function () { res(); }); setTimeout(res, 8000); return; } var s = document.createElement('script'); s.src = src; s.async = false; s.onload = function () { res(); }; s.onerror = function () { res(); }; document.head.appendChild(s); }); return M[src]; }
  function hex(h) { h = h.replace('#', ''); return [parseInt(h.slice(0, 2), 16) / 255, parseInt(h.slice(2, 4), 16) / 255, parseInt(h.slice(4, 6), 16) / 255]; }

  /* 1. Film grain: tiny canvas, regenerated at 12fps, tiled full screen */
  function grain() {
    var c = document.createElement('canvas'); c.width = c.height = 160;
    c.setAttribute('aria-hidden', 'true');
    c.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147482000;opacity:.02;mix-blend-mode:overlay;image-rendering:pixelated';
    var x = c.getContext('2d'), id = x.createImageData(160, 160), d = id.data, last = 0;
    function draw(t) {
      if (!RM) requestAnimationFrame(draw);
      if (t - last < 250) return; last = t;
      for (var i = 0; i < d.length; i += 4) { var v = Math.random() * 255 | 0; d[i] = d[i + 1] = d[i + 2] = v; d[i + 3] = 255; }
      x.putImageData(id, 0, 0);
      c.style.backgroundSize = '160px';
    }
    draw(100); document.body.appendChild(c);
    // stretch the 160px noise into a repeating pattern via CSS background for crisp grain
    var tile = document.createElement('div'); tile.setAttribute('aria-hidden', 'true');
    tile.style.cssText = c.style.cssText; c.style.display = 'none'; document.body.appendChild(tile);
    function sync() { tile.style.backgroundImage = 'url(' + c.toDataURL() + ')'; tile.style.backgroundSize = '160px 160px'; }
    sync(); if (!RM) setInterval(sync, 260);
  }

  /* 2. Shader gradients (three.js ShaderMaterial, domain-warped fbm + posterized bands + baked grain) */
  var FRAG = [
    'precision highp float;uniform float uT;uniform vec2 uR;uniform vec3 c0;uniform vec3 c1;uniform vec3 c2;uniform vec3 c3;uniform float uMix;uniform float uSeed;',
    'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
    'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),f.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),f.x),f.y);}',
    'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<4;i++){v+=a*n(p);p=p*2.02+vec2(1.7,9.2);a*=.5;}return v;}',
    'void main(){vec2 uv=gl_FragCoord.xy/uR;vec2 p=uv*vec2(uR.x/uR.y,1.)*1.4+uSeed;float t=uT*.016;',
    'vec2 q=vec2(fbm(p+t),fbm(p+vec2(5.2,1.3)-t));',
    'vec2 r=vec2(fbm(p+2.2*q+vec2(1.7,9.2)+t*1.4),fbm(p+2.2*q+vec2(8.3,2.8)-t*1.1));',
    'float f=fbm(p+2.4*r);',
    'vec3 col=c0;',
    'col=mix(col,c1,smoothstep(.35,.85,f)*uMix);',
    'col=mix(col,c2,smoothstep(.45,1.05,length(q))*uMix*.85);',
    'col=mix(col,c3,smoothstep(.55,.95,r.y)*uMix*.6);',
    'col=floor(col*28.)/28.;',
    'float g=h(gl_FragCoord.xy+fract(uT)*91.);col+=(g-.5)*.013;',
    'gl_FragColor=vec4(col,1.);}'
  ].join('\n');
  var VERT = 'void main(){gl_Position=vec4(position.xy,0.,1.);}';
  function gradients() {
    var els = [].slice.call(document.querySelectorAll('[data-fx-gradient]'));
    if (!els.length) return;
    els.forEach(function (el, k) {
      if (el.__fx) return; el.__fx = true;
      var cols = el.getAttribute('data-fx-gradient').split(',').map(function (s) { return s.trim(); });
      while (cols.length < 4) cols.push(cols[cols.length - 1]);
      var mix = parseFloat(el.getAttribute('data-fx-mix') || '0.6');
      if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
      [].slice.call(el.children).forEach(function (ch) { var cs = getComputedStyle(ch); if (cs.position === 'static') ch.style.position = 'relative'; if (cs.zIndex === 'auto') ch.style.zIndex = '1'; });
      var r = new THREE.WebGLRenderer({ antialias: false, alpha: false, preserveDrawingBuffer: true, powerPreference: 'low-power' });
      r.setPixelRatio(0.4);
      var cv = r.domElement; cv.setAttribute('aria-hidden', 'true');
      cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;z-index:0;pointer-events:none;display:block;border-radius:inherit';
      if (getComputedStyle(el).borderRadius !== '0px') el.style.overflow = 'hidden';
      el.insertBefore(cv, el.firstChild);
      var u = { uT: { value: k * 13.7 }, uR: { value: new THREE.Vector2(1, 1) }, uMix: { value: mix }, uSeed: { value: k * 3.1 } };
      ['c0', 'c1', 'c2', 'c3'].forEach(function (n, i) { var c = hex(cols[i]); u[n] = { value: new THREE.Vector3(c[0], c[1], c[2]) }; });
      var scene = new THREE.Scene(), cam = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
      scene.add(new THREE.Mesh(new THREE.PlaneGeometry(2, 2), new THREE.ShaderMaterial({ uniforms: u, vertexShader: VERT, fragmentShader: FRAG })));
      function size() { var w = el.clientWidth, h = el.clientHeight; r.setSize(w, h, false); u.uR.value.set(w * r.getPixelRatio(), h * r.getPixelRatio()); r.render(scene, cam); }
      size(); new ResizeObserver(size).observe(el);
      var on = false, t0 = performance.now(), last = 0;
      new IntersectionObserver(function (es) { on = es[0].isIntersecting; }, { rootMargin: '120px' }).observe(el);
      function loop(t) { requestAnimationFrame(loop); if (!on || document.hidden || t - last < 66) return; last = t; u.uT.value = k * 13.7 + (t - t0) / 1000; r.render(scene, cam); }
      if (!RM) requestAnimationFrame(loop);
    });
  }

  /* 3. GSAP scroll motion */
  function motion() {
    if (RM || !window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);
    document.querySelectorAll('[data-fx-parallax]').forEach(function (el) {
      var f = parseFloat(el.getAttribute('data-fx-parallax')) || 0.15;
      gsap.fromTo(el, { yPercent: -f * 50 }, { yPercent: f * 50, ease: 'none', scrollTrigger: { trigger: el.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    document.querySelectorAll('[data-fx-zoom]').forEach(function (el) {
      var img = el.querySelector('img'); if (!img) return;
      gsap.fromTo(img, { scale: 1.14 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom center', scrub: true } });
    });
    var rows = document.querySelectorAll('[data-fx-velocity]');
    if (rows.length) {
      var skew = gsap.quickTo(rows, 'skewX', { duration: .5, ease: 'power3' });
      ScrollTrigger.create({ onUpdate: function (s) { skew(gsap.utils.clamp(-8, 8, s.getVelocity() / -250)); } });
    }
    document.querySelectorAll('h1,h2').forEach(function (h) {
      if (h.closest('[data-module]')) return;
      gsap.fromTo(h, { letterSpacing: '0.04em' }, { letterSpacing: '-0.015em', ease: 'power2.out', scrollTrigger: { trigger: h, start: 'top 92%', end: 'top 55%', scrub: 0.6 } });
    });
    if (FINE) document.querySelectorAll('[data-fx-tilt]').forEach(function (el) {
      var rx = gsap.quickTo(el, 'rotationX', { duration: .6, ease: 'power3' }), ry = gsap.quickTo(el, 'rotationY', { duration: .6, ease: 'power3' });
      gsap.set(el, { transformPerspective: 900 });
      el.parentElement.addEventListener('pointermove', function (e) { var b = el.getBoundingClientRect(); ry(((e.clientX - b.left) / b.width - .5) * 16); rx(-((e.clientY - b.top) / b.height - .5) * 12); });
      el.parentElement.addEventListener('pointerleave', function () { rx(0); ry(0); });
    });
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  }

  /* 4. Locomotive Scroll v5 (Lenis) smooth scrolling on fine pointers */
  function smooth() {
    if (RM || !FINE) return;
    var st = document.createElement('style'); st.textContent = 'html.lenis,html.lenis body{height:auto}.lenis.lenis-smooth{scroll-behavior:auto!important}.lenis.lenis-stopped{overflow:hidden}'; document.head.appendChild(st);
    import('https://cdn.jsdelivr.net/npm/locomotive-scroll@5/+esm').then(function (m) {
      var LS = m.default || m.LocomotiveScroll; if (!LS) return;
      window.__loco = new LS({ lenisOptions: { lerp: 0.1, smoothWheel: true }, scrollCallback: function () { if (window.ScrollTrigger) ScrollTrigger.update(); } });
    }).catch(function (e) { console.warn('locomotive load failed', e); });
  }

  function start() {
    if (!document.querySelector('meta[name="fx-grain"][content="off"]')) grain();
    var three = load('https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js', function () { return !!window.THREE; });
    var gs = load('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js', function () { return !!window.gsap; })
      .then(function () { return load('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js', function () { return !!window.ScrollTrigger; }); });
    // wait for the DC template to finish rendering before wiring sections
    var tries = 0;
    (function wait() {
      var ready = document.querySelector('[data-section="footer"],footer') && document.querySelector('[data-section="hero"]');
      if (!ready && tries++ < 60) return setTimeout(wait, 150);
      three.then(gradients).catch(function (e) { console.warn('three load failed', e); });
      gs.then(motion).catch(function (e) { console.warn('gsap load failed', e); });
      smooth();
      // pick up late-mounted sections (sc-if etc.)
      setTimeout(function () { if (window.THREE) gradients(); }, 2500);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
